import React, { ReactNode } from 'react';
import Alert from '@amzn/meridian/alert';
import Box from '@amzn/meridian/box';
import { AlertProps } from '@amzn/meridian/alert/alert';
import useControllableState from '../hooks/useControllableState';

export interface DismissableAlertProps extends Omit<AlertProps, 'children'> {
  visible?: boolean;
  defaultVisible?: boolean;
  onClose?: () => void;
  children?: ReactNode;
}

const DismissableAlert = ({
  children,
  visible,
  defaultVisible = true,
  onClose,
  ...rest
}: DismissableAlertProps) => {
  const [isVisible, setIsVisible] = useControllableState(
    visible,
    defaultVisible,
    onClose
  );

  if (!isVisible) return null;

  return (
    <Box spacingInset='400 none none none'>
      <Alert onClose={() => setIsVisible(false)} {...rest}>
        {children}
      </Alert>
    </Box>
  );
};

export default DismissableAlert;
